import { ErrorBoundary, Headline } from "@medi24-da2c/web-ui";
import { useTitle } from "@medi24-da2c/web-ui/hooks";
import Cards from "components/Cards";
import AddNewPartner from "components/AddNewPartner";
import CheckPartnerDetails from "components/CheckPartnerDetails";
import UpdatePartner from "../../components/UpdatePartner/UpdatePartner";

function AdminPartnersManagementPage() {
  useTitle("Partners Management");

  return (
    <ErrorBoundary>
      <Headline>Partners management</Headline>
      <Cards>
        <AddNewPartner />
        <CheckPartnerDetails />
        <UpdatePartner />
      </Cards>
    </ErrorBoundary>
  );
}

export default AdminPartnersManagementPage;
